import { render, staticRenderFns } from "./TopCreators.vue?vue&type=template&id=1d8ca574&scoped=true"
import script from "./TopCreators.vue?vue&type=script&lang=js"
export * from "./TopCreators.vue?vue&type=script&lang=js"
import style0 from "./TopCreators.vue?vue&type=style&index=0&id=1d8ca574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ca574",
  null
  
)

export default component.exports